import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { Button, ButtonTheme } from "@redotech/redo-web/button";
import { Modal, ModalSize } from "@redotech/redo-web/modal";
import { memo } from "react";
import * as review from "../review.module.css";

export const InstantExchangeModal = memo(function InstantExchangeModal({
  instantExchangeModalOpen,
  setInstantExchangeModalOpen,
  creatingStripePayment,
  settings,
  submitReturn,
}: {
  instantExchangeModalOpen: boolean;
  setInstantExchangeModalOpen: (open: boolean) => void;
  creatingStripePayment: boolean;
  settings: ReturnAppSettings;
  submitReturn: () => void;
}) {
  return (
    <Modal
      footer={
        <InstantExchangeModalFooter
          creatingStripePayment={creatingStripePayment}
          setInstantExchangeModalOpen={setInstantExchangeModalOpen}
          submitReturn={submitReturn}
        />
      }
      onClose={() => setInstantExchangeModalOpen(false)}
      open={instantExchangeModalOpen}
      size={ModalSize.SMALL}
      title="Instant Exchange"
    >
      <div className={review.modalContainer}>
        <div>
          If you do not return your original items within{" "}
          {settings?.exchanges?.instantExpirationDays || "7"} days you will be
          charged for the exchange order.
        </div>
      </div>
    </Modal>
  );
});

const InstantExchangeModalFooter = memo(function InstantExchangeModalFooter({
  setInstantExchangeModalOpen,
  creatingStripePayment,
  submitReturn,
}: {
  setInstantExchangeModalOpen: (open: boolean) => void;
  creatingStripePayment: boolean;
  submitReturn: () => void;
}) {
  return (
    <>
      <Button
        onClick={() => setInstantExchangeModalOpen(false)}
        theme={ButtonTheme.OUTLINED}
      >
        Cancel
      </Button>
      <Button
        onClick={async function (e) {
          setInstantExchangeModalOpen(false);
          submitReturn();
        }}
        pending={creatingStripePayment}
        theme={ButtonTheme.PRIMARY}
      >
        I understand, submit return
      </Button>
    </>
  );
});
